import React from 'react';
import DriverNavigation from './DriverNavigation';

function DriverLayout({ children }) {
  return (
    <>
      <DriverNavigation />
      <div className="container mx-auto px-4 py-8">
        {children}
      </div>
    </>
  );
}

export default DriverLayout; 